import { useEffect, useMemo, useState } from 'react';

/**
 * Wykrywa tryb mobilny na podstawie szerokości oraz umożliwia ręczne wymuszenie.
 *
 * Wymuszanie (do testów w Chrome na desktopie):
 * - dodaj do URL `?mobile=1` aby włączyć, `?mobile=0` aby wyłączyć
 * - lub ustaw w tej sesji: `sessionStorage.setItem('ui:forceMobile', '1'|'0')`
 */
export const useIsMobile = (breakpointPx: number = 768): boolean => {
  const [width, setWidth] = useState<number>(() => window.innerWidth);

  // Odczyt z URL (jednorazowo na wejściu)
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const flag = params.get('mobile');
      if (flag === '1' || flag === '0') {
        sessionStorage.setItem('ui:forceMobile', flag);
        // Wyczyść stary klucz (gdyby istniał) – mógł powodować "utknięcie"
        try { localStorage.removeItem('ui:forceMobile'); } catch {}
        // Usuń parametr z adresu (czyściej podczas nawigacji)
        const url = new URL(window.location.href);
        url.searchParams.delete('mobile');
        window.history.replaceState({}, document.title, url.toString());
      }
    } catch {}
  }, []);

  // Nasłuch zmiany rozmiaru okna
  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return useMemo(() => {
    // 1) ręczne wymuszenie
    try {
      const forced = sessionStorage.getItem('ui:forceMobile') ?? localStorage.getItem('ui:forceMobile');
      if (forced === '1') return true;
      if (forced === '0') return false;
    } catch {}
    // 2) detekcja po szerokości
    return width < breakpointPx;
  }, [width, breakpointPx]);
};

export default useIsMobile;


